export const QUIZ_INDEX = 'MKTQuizIndex';
export const MKT_QUIZ_ANSWER = 'MKTQuizAnswer';

// social widget event
export const WIDGET_CLICK = 'WIDGET_CLICK';
export const WIDGET_CTA_CLICK = 'WIDGET_CTA_CLICK';



// WEBPACK FOOTER //
// ./app/constants/gtmVariables.js